import { render, staticRenderFns } from "./Importer.vue?vue&type=template&id=61977850"
import script from "./Importer.vue?vue&type=script&lang=js"
export * from "./Importer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports